import { useCallback, useMemo } from "react";

export const useLocalStorage = () => {
    const set = useCallback((key, data) => {
        localStorage.setItem(key, JSON.stringify(data));
    }, []);

    const get = useCallback((key) => {
        const itemStr = localStorage.getItem(key);

        if (!itemStr) {
            return null;
        }
        return JSON.parse(itemStr);
    }, []);

    const setWithExpiry = useCallback((key, data, min) => {
        const now = new Date();
        const item = {
            expiry: new Date(now.getTime() + min * 60000),
            value: data,
        };

        localStorage.setItem(key, JSON.stringify(item));
    }, []);

    const getWithExpiry = useCallback((key) => {
        const itemStr = localStorage.getItem(key);

        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }

        const item = JSON.parse(itemStr);

        const now = new Date();
        const expirity = new Date(item.expiry);

        // compare the expiry time of the item with the current time
        if (now.getTime() > expirity.getTime()) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }, []);

    return useMemo(() => {
        return { setWithExpiry, getWithExpiry, set, get };
    }, [setWithExpiry, getWithExpiry, set, get]);
};
